import { Routes, Route, Navigate } from "react-router-dom";
import StoreSignUp from "./StoreSignUp";
import MasonPartnership from "./MasonPartnership";
import PublicSignUp from "./PublicSignUp";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/MasonPartnership" replace />} />
      <Route path="/StoreSignUp" element={<StoreSignUp />} />
      <Route path="/MasonPartnership" element={<MasonPartnership />} />
      <Route path="/:storeInfo" element={<PublicSignUp />} />
    </Routes>
  );
}

export default App;



